"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Auth = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const yup_1 = require("yup");
const I18n_1 = require("../i18n/I18n");
const UI_1 = require("../ui/UI");
const Identity_1 = require("./Identity");
function Auth() {
    const { t } = I18n_1.useTranslation("identity");
    const { login } = Identity_1.useIdentityContext();
    const { useForm, useFormField } = UI_1.useUIContext();
    const username = useFormField({
        autoFocus: true,
        type: "email",
        name: "username",
        label: t("Username"),
        autoComplete: "email",
        required: true,
    });
    const password = useFormField({
        name: "password",
        label: t("Password"),
        type: "password",
        autoComplete: "current-password",
        required: true,
    });
    return useForm({
        title: t("Sign In"),
        submitButton: t("Sign In"),
        validationSchema: {
            username: yup_1.string()
                .email(t("Username is not a valid email"))
                .required(t("Username is required")),
            password: yup_1.string().required(t("Password is required")),
        },
        initialValues: { username: "", password: "" },
        onSubmit: login,
        children: (jsx_runtime_1.jsxs(jsx_runtime_1.Fragment, { children: [username, password] }, void 0)),
    });
}
exports.Auth = Auth;
//# sourceMappingURL=Auth.js.map